import React from 'react';
import styles from './OrdersTable.module.css';
import { Tag, BtnSecondary } from './Styled';
import { formatCurrency, formatNegative, formatDateTime } from '../utils';

const SearchIcon = () => (
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
    <circle cx="6.5" cy="6.5" r="5" stroke="#B9AFA8" strokeWidth="1.5" />
    <path
      d="M11 11L14.5 14.5"
      stroke="#B9AFA8"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const TYPE_ICON = { Delivery: '🚴', Pickup: '🥡', Dinein: '🍽' };

const OrdersTable = ({
  invoice,
  orders,
  search,
  onSearchChange,
  selectedOrder,
  onSelectOrder,
}) => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <span className={styles.cardTitle}>
        Orders in this Invoice ({invoice.orderCount})
      </span>
      <div className={styles.headerRight}>
        <div className={styles.searchBar}>
          <SearchIcon />
          <input
            className={styles.searchInput}
            placeholder="Search reference…"
            value={search}
            onChange={e => onSearchChange(e.target.value)}
            autoComplete="off"
          />
        </div>
        {/* <BtnSecondary
          onClick={() =>
            invoice.placeCsvUrl && window.open(invoice.placeCsvUrl, '_blank')
          }
        >
          ⬇ CSV
        </BtnSecondary> */}
      </div>
    </div>

    <div className={styles.tableScroll}>
      <div className={styles.tableHeader}>
        <span>Order Ref</span>
        <span>Place</span>
        <span>Date &amp; Time</span>
        <span>Type</span>
        <span className={styles.right}>Sale Value</span>
        <span className={styles.right}>Promo</span>
        <span className={styles.right}>KRV Fee</span>
        <span className={styles.right}>Net Payout</span>
      </div>

      <div>
        {orders.length === 0 ? (
          <div className={styles.noMatch}>
            {search
              ? `No orders match "${search}"`
              : 'No orders in this invoice'}
          </div>
        ) : (
          orders.map(o => {
            const isSelected =
              selectedOrder && selectedOrder.menuOrderId === o.menuOrderId;
            return (
              <div
                key={o.menuOrderId}
                className={`${styles.row} ${isSelected ? styles.selected : ''}`}
                onClick={() => onSelectOrder(o)}
              >
                <div className={styles.orderId}>{o.orderReference}</div>
                <div>
                  <div className={styles.customer}>{o.placeName}</div>
                </div>
                <div className={styles.datetime}>
                  {formatDateTime(o.orderDate)}
                </div>
                <div>
                  <Tag variant="bl" style={{ fontSize: '10.5px' }}>
                    {TYPE_ICON[o.serviceType] || '🍽'} {o.serviceType}
                  </Tag>
                </div>
                <div className={styles.numRight}>
                  {formatCurrency(o.saleValue)}
                </div>
                <div className={styles.numRight}>
                  {o.promo < 0 ? formatNegative(Math.abs(o.promo)) : '—'}
                </div>
                <div className={styles.numRight}>
                  {formatNegative(o.krvFee)}
                </div>
                <div className={`${styles.numRight} ${styles.netPayout}`}>
                  {formatCurrency(o.netPayout)}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>

    <div className={styles.footer}>
      <span className={styles.footerCount}>
        Showing {orders.length} of {invoice.orderCount} orders
      </span>
      {invoice.orderCount > orders.length && (
        <span className={styles.viewAll}>
          View all {invoice.orderCount} orders →
        </span>
      )}
    </div>
  </div>
);

export default OrdersTable;
